<!-- header title and station selection -->
<div style="float:left">
	<h3>Station {{stationID}} Dashboard</h3>
</div>

<div class="col-md-4 form-group" class="horizontal spaceLeft spaceTop" id="selDiv">
	<!-- station selection list -->
	<p-select [options]="stationList" [(ngModel)]="listSelection" [style]="{'width':'600px'}" 
		(ngModelChange)="newStationSelected($event)" [filter]="true">
		<ng-template let-station pTemplate="item">
			<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
            			<div class="{{station.novaScoreClass}} stationListElement">{{station.label}}</div>
        		</div>
		</ng-template>
	</p-select>

	<!-- hamburger download button-->
    <p-menu #menu [popup]="true" [model]="dataAccessOptions" appendTo="body" class="spaceLeft"></p-menu>
    <button id='dataAccessButton' type="button" pButton icon="pi pi-bars" (click)="menu.toggle($event)"></button>
</div>

<div style="clear:both"> </div>
   <!--
			<div id="StationDashboardHighChartsContainer" class="row stationsClass"> </div>
-->

<p-tabs [(value)]="currentTab">
	<p-tablist>
		<p-tab value="data"><i [class]="'pi pi-chart-line'"></i>Data Plots</p-tab>
		@if (alarmList.length>0 ) {
		<p-tab value="alarms"><i [class]="'pi pi-bell'"></i>Alarms ({{alarmList.length}})</p-tab>
		}
		@if (elevationProfile != null) {
		<p-tab value="elevationProfile"><i [class]="'pi pi-bars'"></i>Elevation Profile</p-tab>
		}
		@if (forecastPlotConfiguration != null) {
		<p-tab value="forecastPlot"><img src="/assets/images/forecastPlotIconTransparent.png" width="14">Forecast Plot</p-tab>
		}
		@if (images.length>0) {
		<p-tab value="photos"><i [class]="'pi pi-camera'"></i>Photos/Diagrams ({{images.length}})</p-tab>
		}
	</p-tablist>

	<p-tabpanels>

		<p-tabpanel value="data">


			<!-- general station information -->
			<div style="clear:both"></div>  <!-- puts items in following div on new lines -->
			<div class="row stationsClass">
				<div id="infoDivs">
					<!-- div class="col-md-6" id="StationInformation"> -->
					<div id="StationInformation">
						Station name: {{currentStation.stationName}}<br>
						Station elevation: {{currentStation.stationElevation}}
						@for ( novascore of stationNovaScores; track novascore ) {
						<li>
							<span class={{novascore.novaScoreClass}}>{{novascore.dataType}} - {{novascore.novaScoreDescription}}</span>
						</li>
						}
					</div>

				</div>

				<div>
				</div>

					<!-- period of record selection box -->
					<div style="clear:both"></div>
					<div class="col-md-6" class="moreSpaceTop horizontal">
						<label class="spaceRight">Period of record:</label>
						<p-select [options]="periodOfRecordList"
							[scrollHeight]="'250px'"
							[(ngModel)]='periodOfRecordSelected'
							(ngModelChange)='newPeriodOfRecordSelected($event)' >
						</p-select>
					</div>
					@if ( periodOfRecordSelected=='0' ) {
					<span>
						<span class="spaceLeft"> Start date: </span>
						<p-datepicker [(ngModel)]="startDate" dateFormat="yy-mm-dd" showTime="true" hourFormat="24" showIcon="true"></p-datepicker>
						<span class="spaceLeft"> End date: </span>
						<p-datepicker [(ngModel)]="endDate" dateFormat="yy-mm-dd" showTime="true" hourFormat="24" showIcon="true"></p-datepicker>
						<button pButton type="button" label="Show Data" title="Update Charts" class="spaceLeft" style="vertical-align: inherit"(click)="newPeriodOfRecordSelected('0')"></button>
					</span>
					}

					<div class="spaceTop">
					<label class="spaceRight">Tracker:</label>
					<p-select [options]="trackerOptions"
						[(ngModel)]='tooltipPreference'
						(onChange)='tooltipPreferenceChanged($event)' >
					</p-select>
					</div>

					<!-- 
						<button pButton pRipple type="button" 
							icon="pi pi-undo"
							class="p-button-rounded p-button-text p-button-plain"
							(click)="resetZoom">
						</button>
					-->
				<!-- 
				</div>
				-->
			</div>

			<!-- time series charts -->
			<div style="clear:both"></div>  <!-- puts items in following div on new lines -->
		<!-- -->
			<div id="StationDashboardHighChartsContainer" class="row stationsClass"></div>
			<!-- -->


		</p-tabpanel>

		<p-tabpanel value="alarms">

			<!-- alarm table -->
				<p-table [value] = "alarmList">
					<ng-template pTemplate="header">
						<tr>
							<th>Data Type</th>
							<th>Date/Time</th>
							<th>Alarm Name</th>
							<th>Trigger Value</th>
							<th>Alarm State</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-alarm>
						<tr>
							<td>{{alarm.dataType}}</td>
							<td>{{alarm.alarmDateTime | date:"medium"}}</td>
							<td>{{alarm.alarmName}}</td>
							<td>{{alarm.triggerValue}}</td>
							<td>{{alarm.alarmState}}</td>
						</tr>
					</ng-template>
				</p-table>
		</p-tabpanel>
	
		<p-tabpanel value="photos">
			<div id="pictures">
				<lib-image-viewer [images]="images" [header]="currentStation.stationName"></lib-image-viewer>
			</div>
		</p-tabpanel>

		<p-tabpanel value="forecastPlot">
		</p-tabpanel>

		<p-tabpanel value="elevationProfile">
			<div>
				@if (elevationProfile != null) {
				<lib-grdrawing-area [props]="elevationProfileProps" [config]="elevationProfile"> </lib-grdrawing-area>
				}
			</div>
		</p-tabpanel>

	</p-tabpanels>
</p-tabs>
				<div id="forecastPlotDiv" style="height:100%; display:flex; flex-direction:column"></div>